import { render } from "./DemoForm.vue?vue&type=template&id=4a5b40d0&scoped=true"
import script from "./DemoForm.vue?vue&type=script&lang=ts"
export * from "./DemoForm.vue?vue&type=script&lang=ts"

import "@/styles/components/_demoForm.scss?vue&type=style&index=0&id=4a5b40d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4a5b40d0"

export default script